module.exports = __webpack_public_path__ + "media/images/categoryIcons/climate_change_icon-de4bddb32c862f12f0fe992fced66e1a.svg";